import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-comms-orders-show',
		path: '/dashboard/comms/send_orders/:id',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_comms_orders_show" */ './index'), {
			exportName: 'AdminCommsOrdersShow',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
